import { isValidUrl } from 'src/components/smart-link/smart-link';
import { ComplaintEntityType } from 'src/constants/complaint-entity-type';
import Complaint from 'src/pages/complaint/complaint';
import { EventListItem } from 'src/types/events';
import EventInfo from '../details/event-info';
import css from './item.module.scss';
import { ReactComponent as ExternalLinkIcon } from 'src/assets/external_link.svg';
import { ReactComponent as EventLinkIcon } from 'src/assets/event-arrow.svg';

import { EVENTS } from 'src/constants/routes';
import { Link } from 'react-router-dom';
import { useMemo } from 'react';

interface EventItemProps {
  event: EventListItem;
  showDate?: boolean;
}

export default function Item({ event, showDate }: Readonly<EventItemProps>) {
  const href = useMemo(() => {
    if (!event.articleUrl) {
      return event.url ?? '#';
    } else if (event.articleUrl.includes('pages')) {
      return `${event.articleUrl}`;
    } else {
      return `${event.slug}`;
    }
  }, [event.articleUrl, event.slug, event.url]);

  const isExternal = isValidUrl(href);
  const pages = {
    path: EVENTS.path,
    title: EVENTS.title
  };

  const options = isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : { target: '_self' };

  const renderComplaintWrapper = (
    complaint: React.ReactNode,
    onMouseEnter: (e: React.MouseEvent) => void,
    onMouseLeave: (e: React.MouseEvent) => void
  ) => (
    <Link to={href} state={isExternal ? null : pages} {...options} className={css.eventItem} id={event.slug}>
      <article>
        <picture // NOSONAR
          title={event.title}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}>
          <img src={event.pictureUrl} alt={event.title} />
          {complaint}
        </picture>
        <header>
          <h3>{event.title}</h3> {isExternal ? <ExternalLinkIcon /> : <EventLinkIcon />}
        </header>
        <EventInfo event={event} showDate={showDate} className={css.disabledText} />
      </article>
    </Link>
  );

  return (
    <Complaint
      entityType={ComplaintEntityType.EVENT}
      entityId={event.id}
      targetTitle={event.title}
      wrapper={renderComplaintWrapper}
    />
  );
}
